import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import React, { memo } from "react";
import { PRIVATE_CONTENT_SPINNER_TEST_ID } from "~/constants/testIDs";
export const SharePrivateContentSpinner = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": PRIVATE_CONTENT_SPINNER_TEST_ID,
        className: "flex h-10 items-center justify-center",
        children: /*#__PURE__*/ _jsx(Spinner, {
            className: "mx-auto text-pigeon-300"
        })
    });
});
SharePrivateContentSpinner.displayName = "SharePrivateContentSpinner";
